module.exports = "<p>\r\n    logout works!\r\n</p>"


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/logout/logout.component.html
// module id = ../../../../../src/app/_components/logout/logout.component.html
// module chunks = main